import { Spinner } from "../Spinner";
import { useSearchInThisArea } from "./SearchInThisArea.hooks"
import { Button } from "./SearchInThisArea.styles"

export const SearchInThisArea = () => {
  const { handleClick, isLoading } = useSearchInThisArea();
  return (
    <Button onClick={handleClick} disabled={isLoading}>
      {isLoading && <Spinner />}
      Search in this area
    </Button>
  )
}
